(function () {
  // Liquid依存値（現記事情報・選択ID・blog URL）はJSON設定ブロックから取得。
  // JS本体を静的化＝全記事ページでCDN/ブラウザキャッシュを共有させるため。
  var cfgEl = document.getElementById('related-articles-config');
  if (!cfgEl) return;
  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  // HTML/属性に値を差し込む際のエスケープ（タイトルやタグに " < & 等が含まれてもカードが壊れない）
  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  class RelatedArticles {
    constructor(config) {
      this.currentArticle = {
        id: config.id,
        title: config.title,
        tags: config.tags
      };

      // メタフィールドから関連記事ID（list.article_reference型）
      this.selectedArticleIds = config.selectedArticleIds || [];

      // 記事データ(スコア計算用 id/title/tags + 表示用 url/image/tagsJa)は別エンドポイントから
      // 遅延取得する。記事ページのHTMLには記事データをインラインしない（1000件規模でも初期HTML
      // が肥大化しない）。全記事ページで内容共通＝ブラウザ/CDNキャッシュが効く。
      this.dataUrl = config.blogUrl + '?view=related-data';

      // 状態表示の文言（Liquidの翻訳から設定ブロック経由で受け取る）
      this.i18n = config.i18n || {};

      // 現記事タイトルの語は全記事で共通 → 1度だけトークン化して使い回す（記事ごとの再計算を排除）
      this.currentWords = this.tokenize(this.currentArticle.title);
      // 各現語の文字集合。Jaro-Winkler事前スキップ（共通文字ゼロ→JW=0確定）に使う
      this.currentWordChars = this.currentWords.map(w => new Set(w));

      this.init();
    }

    // テキストを単語に分割（日本語対応）
    tokenize(text) {
      return text.toLowerCase()
        .replace(/[、。！？（）【】｜]/g, ' ')
        .replace(/([ァ-ヶー]+)/g, ' $1 ') // カタカナを分離
        .replace(/([A-Za-z]+)/g, ' $1 ') // 英数字を分離
        .split(/\s+/)
        .filter(word => word.length > 1);
    }

    // 文字列の類似度を計算（Jaro-Winkler距離）
    jaroWinklerDistance(s1, s2) {
      if (s1 === s2) return 1.0;

      const len1 = s1.length;
      const len2 = s2.length;

      if (len1 === 0 || len2 === 0) return 0.0;

      const matchWindow = Math.floor(Math.max(len1, len2) / 2) - 1;
      const s1Matches = new Array(len1).fill(false);
      const s2Matches = new Array(len2).fill(false);

      let matches = 0;
      let transpositions = 0;

      // マッチング検出
      for (let i = 0; i < len1; i++) {
        const start = Math.max(0, i - matchWindow);
        const end = Math.min(i + matchWindow + 1, len2);

        for (let j = start; j < end; j++) {
          if (s2Matches[j] || s1[i] !== s2[j]) continue;
          s1Matches[i] = true;
          s2Matches[j] = true;
          matches++;
          break;
        }
      }

      if (matches === 0) return 0.0;

      // 転置計算
      let k = 0;
      for (let i = 0; i < len1; i++) {
        if (!s1Matches[i]) continue;
        while (!s2Matches[k]) k++;
        if (s1[i] !== s2[k]) transpositions++;
        k++;
      }

      const jaro = (matches / len1 + matches / len2 + (matches - transpositions / 2) / matches) / 3;

      // Winkler補正
      let prefix = 0;
      for (let i = 0; i < Math.min(len1, len2, 4); i++) {
        if (s1[i] === s2[i]) prefix++;
        else break;
      }

      return jaro + (0.1 * prefix * (1 - jaro));
    }

    // 記事の類似度を計算
    // ※ 手動選択記事は呼び出し側(displayRelatedArticles)で事前に除外するため、
    //   ここに渡るのは自動補完候補のみ。手動選択の優先付け(旧+10000)は不要。
    calculateSimilarity(article) {
      let score = 0;

      // タグの重複をチェック（高い重み）
      const commonTags = this.currentArticle.tags.filter(tag =>
        article.tags.includes(tag)
      );
      score += commonTags.length * 3;

      // タイトルの単語レベル類似度（currentWords はコンストラクタで計算済みを再利用）
      const currentWords = this.currentWords;
      const articleWords = this.tokenize(article.title);

      let titleSimilarityScore = 0;

      // 完全一致の単語（currentWords を走査し、記事語の Set で O(1) 判定＝従来と同一の数え方）
      const articleWordSet = new Set(articleWords);
      for (const word of currentWords) {
        if (articleWordSet.has(word)) {
          titleSimilarityScore += 2;
        }
      }

      // 部分一致・類似単語
      for (let ci = 0; ci < currentWords.length; ci++) {
        const currentWord = currentWords[ci];
        const currentChars = this.currentWordChars[ci];
        for (const articleWord of articleWords) {
          if (currentWord === articleWord) continue;
          // 安全ガード: 共通文字が1つも無ければ Jaro-Winkler は必ず0（閾値0.8未満）→ 計算前にスキップ。
          // 捨てるのは結果に影響しないペアだけなので、スコア・順位は従来と完全に同一。
          let shareChar = false;
          for (const ch of articleWord) {
            if (currentChars.has(ch)) { shareChar = true; break; }
          }
          if (!shareChar) continue;

          const similarity = this.jaroWinklerDistance(currentWord, articleWord);
          if (similarity > 0.8) {
            titleSimilarityScore += similarity;
          }
        }
      }

      score += titleSimilarityScore;

      return score;
    }

    // 記事カードのHTMLを生成（値はすべてエスケープして差し込む）
    createArticleCard(article) {
      const title = escapeHtml(article.title);
      const url = escapeHtml(article.url);
      const imageHtml = article.image ?
        `<img src="${escapeHtml(article.image)}" alt="${escapeHtml(article.imageAlt || article.title || '')}" class="C-related-article-image" loading="lazy" width="400" height="225">` :
        `<div class="C-related-article-image" style="background-color: #f0f0f0; display: flex; align-items: center; justify-content: center; color: #999;">画像なし</div>`;

      const displayTags = article.tagsJa && article.tagsJa.length ? article.tagsJa : article.tags;
      const tagsHtml = displayTags.slice(0, 3).map(tag =>
        `<span class="article-card-tag font10 b-radius-half">${escapeHtml(tag)}</span>`
      ).join('');

      return `
        <a href="${url}" class="C-related-article-card full-unstyled-link b-shadow b-radius" title="${title}">
          ${imageHtml}
          <div class="C-related-article-content">
            <div class="C-related-article-tags">
              ${tagsHtml}
            </div>
            <h3 class="font14 font12-sp">${title}</h3>
          </div>
        </a>
      `;
    }

    // 1ページぶんの記事データを取得（失敗時は null）
    async fetchPage(page) {
      try {
        const sep = this.dataUrl.includes('?') ? '&' : '?';
        const res = await fetch(`${this.dataUrl}${sep}page=${page}`, { headers: { Accept: 'application/json' } });
        if (!res.ok) return null;
        return JSON.parse(await res.text());
      } catch (e) {
        return null;
      }
    }

    // 全記事データを取得。250件超は複数ページに分かれるため、1ページ目で総ページ数を得てから
    // 残りページ(2..N)を並列 fetch して結合する（1000件規模に対応）。
    async fetchAllArticles() {
      const first = await this.fetchPage(1);
      if (!first || !Array.isArray(first.articles)) return [];

      let articles = first.articles;
      const pages = first.pages || 1;

      if (pages > 1) {
        const rest = await Promise.all(
          Array.from({ length: pages - 1 }, (_, i) => this.fetchPage(i + 2))
        );
        rest.forEach(r => {
          if (r && Array.isArray(r.articles)) articles = articles.concat(r.articles);
        });
      }
      return articles;
    }

    // 関連記事を表示
    async displayRelatedArticles() {
      const grid = document.getElementById('related-articles-grid');

      const MAX = 6;
      // 手動選択カードは Liquid で確定描画済み。JSは一切触らず、不足分だけを補完する。
      const manualCount = grid.querySelectorAll('[data-related-source="manual"]').length;
      const need = MAX - manualCount;

      // 手動選択だけで枠が埋まっている → fetch もスコアリングも不要（サーバー描画のまま）
      if (need <= 0) return;

      const autoCards = grid.querySelectorAll('[data-related-source="auto"]');
      // 種リンク（手動 or 自動の実カード）があるか。失敗時はこれを残す（SEO/UX劣化を防ぐ）
      const hasSeed = manualCount > 0 || autoCards.length > 0;

      // 1. 全記事データを取得（複数ページ結合）
      const allArticles = await this.fetchAllArticles();
      if (allArticles.length === 0) {
        // fetch失敗。種リンクがあればそのまま残し、無い時だけエラー表示
        if (!hasSeed) {
          grid.innerHTML = `<div class="C-related-articles-loading">${this.i18n.error || ''}</div>`;
        }
        return;
      }

      // 2. 自分・手動選択を除外し、類似度でソートして不足分（need件）を確保
      //    （スコアリングは従来と同一ロジック・同一精度）
      const selectedSet = new Set(this.selectedArticleIds || []);
      const fill = allArticles
        .filter(article => article.id !== this.currentArticle.id && !selectedSet.has(article.id))
        .map(article => ({
          ...article,
          similarity: this.calculateSimilarity(article)
        }))
        .filter(article => article.similarity > 0)
        .sort((a, b) => b.similarity - a.similarity)
        .slice(0, need);

      if (fill.length === 0) {
        // スコア該当なし。種リンクがあればそのまま残し、無い時だけ「見つかりません」表示
        if (!hasSeed) {
          grid.innerHTML = `<div class="C-related-articles-loading">${this.i18n.empty || ''}</div>`;
        }
        return;
      }

      // 3. 自動枠（サーバー描画の種リンク）だけをスコア版に差し替え。手動カードは不変。
      const fillHtml = fill.map(article => this.createArticleCard(article)).join('');
      if (hasSeed) {
        autoCards.forEach(el => el.remove());
        grid.insertAdjacentHTML('beforeend', fillHtml);
      } else {
        // 種リンクが無い（loading表示のみ）→ まるごと差し替え
        grid.innerHTML = fillHtml;
      }
    }

    // 初期化
    init() {
      // DOMが読み込まれてから遅延読み込みをセットアップ
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.observeAndLoad());
      } else {
        this.observeAndLoad();
      }
    }

    // 関連記事セクションが画面に近づいたら初めてデータ取得＆描画する（遅延読み込み）。
    // 記事末尾のため、そこまでスクロールしないユーザーでは fetch/スコアリングが走らない。
    observeAndLoad() {
      const grid = document.getElementById('related-articles-grid');
      if (!grid) return;

      // IntersectionObserver 非対応環境では従来どおり即読み込み
      if (!('IntersectionObserver' in window)) {
        this.displayRelatedArticles();
        return;
      }

      let triggered = false;
      const io = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || triggered) return;
          triggered = true;
          obs.disconnect();
          this.displayRelatedArticles();
        });
      }, { rootMargin: '600px 0px' }); // 表示の手前で先読みして待ち時間をなくす

      io.observe(grid);
    }
  }

  // 関連記事システムを初期化
  new RelatedArticles(cfg);
})();
